<script>
  import TextEditor from "../Common/TextEditor.svelte";
  import { styleParser, getStyleValue, ignore } from '../Common/tools';
  import {render} from './component-config';
  import FloatingBar from "./FloatingBar.svelte";
  import {onMount} from "svelte";
  import {initResizable} from "./global";
  import {External} from "../external";

  export let id, data, meta, globalStyle, onFocus = ignore;
  export let onChange = ignore, onAction = ignore, isFixed = false;
  let focusElement, top, bottom;
  const components = render();

	function change(value) {
		onChange(value);
		data = Object.assign({}, data, {['content']: value});
	}

	function focus() {
		onFocus(id);
		External.$('.focus-element').css('z-index', 'unset').removeClass('focused');
		External.$(focusElement).css('z-index', '10').addClass('focused');
	}

	onMount(function () {
		let jqTop = External.$(top);
		let jqBottom = External.$(bottom);

		let resizeTop = function (event, ui) {
			if (ui.size.height < 0) {
				ui.size.height = 0;
			}
			data.style = Object.assign({}, data.style, {paddingTop: ui.size.height + "px"});
		};

		let resizeBottom = function (event, ui) {
			if (ui.size.height < 0) {
				ui.size.height = 0;
			}
			data.style = Object.assign({}, data.style, {paddingBottom: ui.size.height + "px"});
		};

		let onStop = function () {
			onChange('padding');
		};

		initResizable(jqTop, resizeTop, jqBottom, resizeBottom, onStop, focus);
	});
</script>
<script context="module">
	import {blurAll} from "../Common/TextEditor.svelte";
	import {External as ExternalLibs} from "../external";

	export function blurSections() {
		blurAll();
		ExternalLibs.$('.focus-element').css('z-index', '').removeClass('focused');
	}
</script>
<style>
	.focus-element {
		z-index: 10;
		position: relative;
	}
</style>
<table class="row focus-element" bgcolor={data.style.backgroundColor} cellpadding="0" cellspacing="0"
			 role="presentation" align="center" on:click={focus} bind:this={focusElement}
			 style="min-width:{globalStyle.width};">
	<tbody>
	{#if !data.isFullscreen}
		<tr>
			<th class="spacer" height="{getStyleValue(data.style.paddingTop, '40')}"
					style="line-height: {data.style.paddingTop || '40px'};position: relative;">
				<div class="spacer-top" bind:this={top}
						 style="top:0;position:absolute;width:100%;height:{data.style.paddingTop || '40px'}">
					<FloatingBar id={id} onAction={onAction} disabled={isFixed} globalStyle={globalStyle}/>
				</div>
			</th>
		</tr>
	{:else}
		<tr>
			<td>
				<FloatingBar id={id} onAction={onAction} disabled={isFixed} globalStyle={globalStyle}/>
			</td>
		</tr>
	{/if}
	{#if !data.type}
		<tr>
			<th class="column column-st" width="{getStyleValue(globalStyle.width, 600)}"
					style={'padding-left: 40px; padding-right: 40px;' + styleParser(data.style, ['paddingTop', 'paddingBottom'])}>
				<TextEditor onChange={change} meta={meta} data={data.content} emailEditor={true}/>
			</th>
		</tr>
	{:else}
		<svelte:component this={components[data.type]} bind:data={data} meta={meta} globalStyle={globalStyle} onChange={onChange} onFocus={focus}/>
	{/if}
	{#if !data.isFullscreen}
		<tr>
			<td class="spacer" height="{getStyleValue(data.style.paddingBottom, '40')}"
					style="line-height: {data.style.paddingBottom || '40px'};">
				<div class="spacer-bottom" bind:this={bottom}
						 style="bottom:0;position:absolute;width:100%;height:{data.style.paddingBottom || '40px'}">
					&nbsp;
				</div>
			</td>
		</tr>
	{/if}
	</tbody>
</table>
